import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ManagerSidebar from '../components/Sidebar/ManagerSidebar';

const API_BASE_URL = 'https://ikaze-thouse-backend.vercel.app/api/v1';

const GuardList = () => {
    const [guards, setGuards] = useState([]);
    const navigate = useNavigate();

    // FETCH ALL GUARDS
    const fetchGuards = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/guards`);
            setGuards(res.data);
        } catch (err) {
            console.error("Error fetching guards:", err);
        }
    };

    useEffect(() => {
        fetchGuards();
    }, []);

    // DELETE GUARD
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this guard?")) return;

        try {
            await axios.delete(`${API_BASE_URL}/guards/${id}`);
            setGuards(guards.filter(g => g.id !== id));
        } catch (err) {
            console.error("Delete error:", err);
        }
    };

    return (
        <div className="page-container">
            <ManagerSidebar />

            <div className="content">
                <div className="header">
                    <h2>Guards List</h2>
                    <button onClick={() => navigate('/add-guard')} className="add-btn">
                        + Add Guard
                    </button>
                </div>

                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Gender</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {guards.length > 0 ? (
                            guards.map((guard) => (
                                <tr key={guard.id}>
                                    <td>{guard.id}</td>
                                    <td>{guard.name}</td>
                                    <td>{guard.phone}</td>
                                    <td>{guard.gender}</td>
                                    <td>{guard.status}</td>
                                    <td>
                                        <button
                                            className="edit-btn"
                                            onClick={() => navigate(`/edit-guard/${guard.id}`)}
                                        >
                                            Edit
                                        </button>

                                        <button
                                            className="delete-btn"
                                            onClick={() => handleDelete(guard.id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">No guards found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* SIMPLE CSS */}
            <style>{`
                /* PAGE LAYOUT */
.page-container {
    display: flex;
    min-height: 100vh;
    background: #f1f5f9;
    font-family: Arial, sans-serif;
}

/* MAIN CONTENT */
.content {
    flex: 1;
    padding: 30px;
    overflow-x: auto;
}

/* HEADER */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    background: white;
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.06);
}

.header h2 {
    color: #0f172a;
    font-size: 28px;
}

/* ADD BUTTON */
.add-btn {
    background: linear-gradient(135deg, #06b6d4, #2563eb);
    color: white;
    border: none;
    padding: 12px 18px;
    cursor: pointer;
    font-weight: bold;
    border-radius: 10px;
    transition: 0.3s;
    font-size: 14px;
    box-shadow: 0 4px 10px rgba(37,99,235,0.3);
}

.add-btn:hover {
    transform: translateY(-2px);
    opacity: 0.9;
}

/* TABLE CONTAINER */
.table-wrapper {
    background: white;
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    overflow-x: auto;
}

/* TABLE */
.table {
    width: 100%;
    border-collapse: collapse;
    min-width: 700px;
}

/* TABLE HEAD */
.table thead {
    background: #2563eb;
    color: white;
}

.table th {
    padding: 16px;
    text-align: left;
    font-size: 15px;
}

/* TABLE BODY */
.table td {
    padding: 14px 16px;
    border-bottom: 1px solid #e2e8f0;
    color: #334155;
    font-size: 14px;
}

/* HOVER EFFECT */
.table tbody tr {
    transition: 0.2s;
}

.table tbody tr:hover {
    background: #f8fafc;
}

/* EDIT BUTTON */
.edit-btn {
    background: #facc15;
    color: #111827;
    border: none;
    padding: 8px 14px;
    margin-right: 8px;
    cursor: pointer;
    border-radius: 8px;
    font-weight: bold;
    transition: 0.3s;
}

.edit-btn:hover {
    background: #eab308;
}

/* DELETE BUTTON */
.delete-btn {
    background: #ef4444;
    color: white;
    border: none;
    padding: 8px 14px;
    cursor: pointer;
    border-radius: 8px;
    font-weight: bold;
    transition: 0.3s;
}

.delete-btn:hover {
    background: #dc2626;
}

/* EMPTY ROW */
.table td[colspan] {
    text-align: center;
    padding: 30px;
    color: #64748b;
    font-style: italic;
}

/* RESPONSIVE */
@media (max-width: 768px) {

    .header {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
    }

    .content {
        padding: 15px;
    }

    .table-wrapper {
        padding: 10px;
    }
}
            `}</style>
        </div>
    );
};

export default GuardList;